import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// Create axios instance
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth APIs
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (email, password) => {
    const formData = new URLSearchParams();
    formData.append('username', email);
    formData.append('password', password);
    return api.post('/auth/login', formData, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  },
  getCurrentUser: () => api.get('/auth/me'),
};

// Wardrobe APIs
export const wardrobeAPI = {
  addItem: (file, itemName, category) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('item_name', itemName || file.name.split('.')[0]);
    if (category) formData.append('category', category);
    return api.post('/wardrobe/add', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  
  testUpload: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/test/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  
  getItems: () => api.get('/wardrobe/items'),
  
  getItem: (itemId) => api.get(`/wardrobe/item/${itemId}`),
  
  getHistory: (limit = 20) => api.get(`/wardrobe/history?limit=${limit}`),
  
  addBatchItems: (file, category) => {
    const formData = new FormData();
    formData.append('file', file);
    if (category) formData.append('category', category);
    return api.post('/wardrobe/add-batch', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 300000, // 5 minutes timeout for batch processing
    });
  },
  
  tryOn: (itemId, personImage, customPrompt, outfitId = null) => {
    const formData = new FormData();
    if (outfitId) {
      formData.append('outfit_id', outfitId);
    } else {
      formData.append('item_id', itemId);
    }
    formData.append('person_image', personImage);
    if (customPrompt) formData.append('prompt', customPrompt);
    return api.post('/wardrobe/try-on', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 120000, // 2 minutes timeout for try-on
    });
  },
};

// Outfit APIs
export const outfitAPI = {
  createOutfit: (name, description, itemIds, occasion, season) => 
    api.post('/outfits/', {
      name,
      description,
      item_ids: itemIds,
      occasion,
      season,
    }),
  
  getOutfits: () => api.get('/outfits/'),
  
  getOutfit: (outfitId) => api.get(`/outfits/${outfitId}`),
  
  updateOutfit: (outfitId, data) => api.put(`/outfits/${outfitId}`, data),
  
  deleteOutfit: (outfitId) => api.delete(`/outfits/${outfitId}`),
};

export default api;
